import { render } from "./vistaProds3.vue?vue&type=template&id=d1339be4&scoped=true"
import script from "./vistaProds3.vue?vue&type=script&lang=js"
export * from "./vistaProds3.vue?vue&type=script&lang=js"

import "./vistaProds3.vue?vue&type=style&index=0&id=d1339be4&scoped=true&lang=css"

import exportComponent from "C:\\paginascedis\\general\\cedispage2.0_general_cecra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1339be4"]])

export default __exports__